"use strict";

function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);

    return o;
}
exports._ = _object_destructuring_empty;
